import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import isEmpty from 'lodash.isempty';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../../../components/userStore';
import { useApplicationStore } from './applicationStore';

const reformatDate = (origDateStr) => {
	const [year, month, day] = origDateStr.split('-');
	return `${month}/${day}/${year}`;
};

const MemberFileSearch = () => {
	const { user } = useUserStore();
	const [fName, setFName] = useState('');
	const [lName, setLName] = useState('');
	const [dateOfBirth, setDateOfBirth] = useState('');
	const navigate = useNavigate();
	const {
		setNameFirst,
		setNameLast,
		setEmail,
		setMobile,
		setDob,
		setAddress,
		setCity,
		setState,
		setZip,
		setHealthplan,
		setSubscriberId,
		setStatus,
		setReimbursable,
		setExistingClient,
		resetClient,
	} = useApplicationStore();
	const searchQuery = useQuery({
		queryKey: ['ilos-member-file-search', fName, lName, dateOfBirth],
		queryFn: async () => {
			const { data } = await axios.get(`/coords/ilos-member-file-search`, {
				params: {
					first_name: isEmpty(fName) ? null : fName,
					last_name: isEmpty(lName) ? null : lName,
					dob: isEmpty(dateOfBirth) ? null : reformatDate(dateOfBirth),
				},
			});
			return data;
		},
		enabled: false,
		retry: false,
	});

	const handleSearch = (event) => {
		event.preventDefault();
		searchQuery.refetch();
		resetClient();
	};

	const handleMemberChosen = (member) => {
		const [month, day, year] = member.dob.split('/');
		const address = [member.address_1];
		if (!isEmpty(member.address_2)) {
			address.push(member.address_2);
		}
		if (member.id) {
			setExistingClient({ id: member.id });
			setStatus(undefined);
		} else {
			setStatus('stubbed/hp');
		}
		setNameFirst(member.first_name);
		setNameLast(member.last_name);
		setEmail(member.email);
		setMobile(member.mobile_number);
		setDob([year, month, day].join('-'));
		setAddress(address.join(', '));
		setCity(member.city);
		setState(member.state);
		setZip(member.postal_code);
		setHealthplan(`${user.coord_agency_id}`);
		setSubscriberId(member.medicaid_unique_id);
		setReimbursable(true);
		navigate('/newApplication/profile/new');
	};

	return (
		<>
			<input type="hidden" name="step" value="client" />
			<h1>Member File Search</h1>
			<p>
				<em>Find client by name or date of birth from uploaded members file</em>
			</p>
			<div className="flex flex-row items-end gap-4">
				<div className="form-control">
					<label className="label">First Name</label>
					<input
						type="text"
						className="input input-bordered"
						value={fName}
						onChange={({ target }) => setFName(target.value)}
						autoComplete="off"
					/>
				</div>
				<div className="form-control">
					<label className="label">Last Name</label>
					<input
						type="text"
						className="input input-bordered"
						value={lName}
						onChange={({ target }) => setLName(target.value)}
						autoComplete="off"
					/>
				</div>
				<div className="form-control">
					<label className="label">Date of Birth</label>
					<input
						type="date"
						className="input input-bordered"
						value={dateOfBirth}
						onChange={({ target }) => setDateOfBirth(target.value)}
						autoComplete="off"
					/>
				</div>
				<button
					className="btn btn-primary"
					onClick={handleSearch}
					disabled={
						searchQuery.isFetching ||
						(isEmpty(fName) && isEmpty(lName) && isEmpty(dateOfBirth))
					}
				>
					{searchQuery.isFetching && (
						<span className="loading loading-spinner"></span>
					)}
					Search
				</button>
			</div>
			{searchQuery.isFetched && (
				<table className="table mt-4 table-zebra">
					<thead>
						<tr>
							<td>First Name</td>
							<td>Last Name</td>
							<td>DOB</td>
							<td>Member ID</td>
							<td colSpan={2}>Tandem Client Account</td>
						</tr>
					</thead>
					<tbody>
						{searchQuery.isFetched && searchQuery?.data?.length === 0 && (
							<tr>
								<td colSpan={5}>No data found</td>
							</tr>
						)}
						{searchQuery.data.map((member) => (
							<tr key={member.medicaid_unique_id}>
								<td>{member.first_name}</td>
								<td>{member.last_name}</td>
								<td>{member.dob}</td>
								<td>{member.medicaid_unique_id}</td>
								<td>{member.id ? 'Yes' : 'No'}</td>
								<td className="text-right">
									<button
										className="btn btn-primary btn-sm"
										type="submit"
										onClick={() => handleMemberChosen(member)}
									>
										Choose
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			)}
		</>
	);
};

export default MemberFileSearch;
